import { render, staticRenderFns } from "./PersonnalInfos.vue?vue&type=template&id=f98789d8"
import script from "./PersonnalInfos.vue?vue&type=script&lang=js"
export * from "./PersonnalInfos.vue?vue&type=script&lang=js"
import style0 from "./PersonnalInfos.vue?vue&type=style&index=0&id=f98789d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports